import { Component } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { FormFieldModule, TextBoxModule } from '@progress/kendo-angular-inputs';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { catchError, EMPTY, switchMap, take, tap, throwError } from 'rxjs';
import { AuthorizationService } from '../../services/authorization/authorization.service';
import { RoutingService } from '../../services/routing/routing.service';
import { LabelModule } from '@progress/kendo-angular-label';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { FormErrorComponent } from '../../shared/components/form-error/form-error.component';
import { Router } from '@angular/router';
import { AfRoutes } from '../../routes';
import { ToastService } from '../../services/toast/toast.service';
import { NotificationService } from '@progress/kendo-angular-notification';

@Component({
  selector: 'af-confirm-totp-mfa',
  imports: [
    ButtonModule,
    LabelModule,
    FormFieldModule,
    TextBoxModule,
    ReactiveFormsModule,
    LabelModule,
    FormErrorComponent,
  ],
  templateUrl: './confirm-totp-mfa.component.html',
  styleUrl: './confirm-totp-mfa.component.scss',
  providers: [ToastService, NotificationService],
})
export class ConfirmTotpMfaComponent {
  mfaForm = new FormGroup({
    code: new FormControl('', [Validators.required]),
  });
  errorMessage?: string;
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private authorizationService: AuthorizationService,
    private routingService: RoutingService,
    private toastService: ToastService
  ) {}

  confirmMfa() {
    const { code } = this.mfaForm.value;
    if (!this.mfaForm.valid || !code) {
      this.errorMessage = 'Missing code';
      return;
    }
    this.authenticationService
      .confirmUserSignIn(code)
      .pipe(
        switchMap(() => this.authorizationService.updateRoles()),
        tap(() => this.routingService.navigateToDashboard()),
        take(1),
        catchError((error) => {
          if ('name' in error) {
            if (error.name === 'CodeMismatchException') {
              this.errorMessage = 'Invalid code';
            } else if (error.name === 'ExpiredCodeException') {
              this.errorMessage = 'Code expired';
            } else {
              console.error({ error });
              this.toastService.showErrorMessage(
                'MFA Authentication timed out. Please try again.'
              );
              this.router.navigate([AfRoutes.login]);
            }
          }
          return EMPTY;
        })
      )
      .subscribe();
  }
}
